module.exports = __webpack_public_path__ + "img/knowledge_top.5a8a9237.png";